import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthorizationService } from '../authorization/authorization.service';
import { AuthenticationService } from '../services/authentication.service';

/** UX-only permission guard. The API remains the authorization authority. */
export function permissionGuard(...requiredPermissions: string[]): CanActivateFn {
  return (_route, state) => {
    const authentication = inject(AuthenticationService);
    const authorization = inject(AuthorizationService);
    const router = inject(Router);

    if (!authentication.isLoggedIn()) {
      return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
    }

    return authorization.hasAllPermissions(...requiredPermissions)
      ? true
      : router.parseUrl('/home');
  };
}

/** Grants entry when the token holds any of the listed permissions. */
export function anyPermissionGuard(...requiredPermissions: string[]): CanActivateFn {
  return (_route, state) => {
    const authentication = inject(AuthenticationService);
    const authorization = inject(AuthorizationService);
    const router = inject(Router);

    if (!authentication.isLoggedIn()) {
      return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
    }

    return authorization.hasAnyPermission(...requiredPermissions)
      ? true
      : router.parseUrl('/home');
  };
}
